import { useEffect, useRef, useState } from "react";

const CALENDLY_URL =
  process.env.REACT_APP_CALENDLY_URL ||
  "https://calendly.com/wholesalersuniversity/1-on-1-call";

export default function Book() {
  const containerRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const cssId = "calendly-css";
    if (!document.getElementById(cssId)) {
      const link = document.createElement("link");
      link.id = cssId;
      link.rel = "stylesheet";
      link.href = "https://assets.calendly.com/assets/external/widget.css";
      document.head.appendChild(link);
    }

    const scriptId = "calendly-script";
    const mount = () => {
      if (!containerRef.current || !window.Calendly) return;
      containerRef.current.innerHTML = "";
      const isLight = document.documentElement.getAttribute("data-theme") === "light";
      window.Calendly.initInlineWidget({
        url: `${CALENDLY_URL}?hide_gdpr_banner=1&hide_landing_page_details=1&hide_event_type_details=0&background_color=${isLight ? "ffffff" : "0a0a0a"}&text_color=${isLight ? "0a0a0a" : "ffffff"}&primary_color=C5E26A`,
        parentElement: containerRef.current,
      });
      setLoaded(true);
    };

    if (window.Calendly) {
      mount();
    } else if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      script.onload = mount;
      document.body.appendChild(script);
    } else {
      const interval = setInterval(() => {
        if (window.Calendly) {
          clearInterval(interval);
          mount();
        }
      }, 100);
      return () => clearInterval(interval);
    }
  }, []);

  return (
    <div data-testid="book-page">
      <div className="mb-8">
        <div className="section-tag mb-3"><span className="dot" /> Coaching</div>
        <h1 className="h-display text-3xl sm:text-4xl">Book a Call</h1>
      </div>

      <div
        className="surface-card overflow-hidden relative"
        style={{ padding: 0, minHeight: 760 }}
        data-testid="calendly-embed"
      >
        {!loaded && (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 z-10" style={{ background: "var(--surface)" }}>
            <span className="spinner" />
            <div className="font-mono text-xs uppercase tracking-wider" style={{ color: "var(--text-muted)" }}>
              Loading calendar…
            </div>
          </div>
        )}
        <div
          ref={containerRef}
          style={{ minWidth: 320, width: "100%", height: 760 }}
        />
      </div>
    </div>
  );
}
